import { render, staticRenderFns } from "./GameDebug.vue?vue&type=template&id=647eab54&scoped=true"
import script from "./GameDebug.vue?vue&type=script&lang=js"
export * from "./GameDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647eab54",
  null
  
)

export default component.exports